import { ExpertiseArticleDetail } from '@components'

export const ExpertiseArticleLayout = () => {
    return (
        <>
            <ExpertiseArticleDetail />
            {/* <ShouldLike /> */}
        </>
    )
}
